import { useEffect } from 'react'

import { useSequenceInfiniteQuery } from '@sequencehq/api'
import { dashboardv20240509Client } from '@sequencehq/api/dashboard/v20240509'
import { HOURS } from '@sequencehq/utils/dates'

export const usePrefetchAllProducts = () => {
  const productsInfiniteQuery = useSequenceInfiniteQuery(
    dashboardv20240509Client.getProducts,
    { limit: 100 },
    {
      staleTime: 1 * HOURS,
      maxPages: 16,
      refetchOnWindowFocus: false
    }
  )

  useEffect(() => {
    if (
      productsInfiniteQuery.infiniteQuery.hasNextPage &&
      !productsInfiniteQuery.infiniteQuery.isPending
    ) {
      productsInfiniteQuery.infiniteQuery.fetchNextPage()
    }
  }, [
    productsInfiniteQuery,
    /** Needed to trigger the useEffect and exhaust the entire set of products */
    productsInfiniteQuery.infiniteQuery.data?.pages.length
  ])
}
